
























































































import {Component, Prop} from 'vue-property-decorator'
import MyWalletTokensTable from '@/components/myWallet/MyWalletTokensTable.vue'
import Tooltip from '@/components/tooltip/Tooltip.vue'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import MyWalletMyNfts from '@/components/myWallet/MyWalletMyNfts.vue'
import {MyWalletCacheAssist} from '@/helpers/MyWalletCacheAssist'
import {$} from '@/facade'
import SwapModal from '@/components/SwapModal.vue'

@Component({
  components: {
    SwapModal,
    MyWalletMyNfts,
    Tooltip,
    MyWalletTokensTable,
  },
  computed: {
    $() {
      return $
    },
  },
})
export default class MyWalletTokensNftsSection extends MixinScreenSize {
  @Prop({type: MyWalletCacheAssist, required: true})
  cacheAssist!: MyWalletCacheAssist

  isTokensTableVisible = true
}
